import axios from "../api";
// 本馆介绍
const get_traffic_info = () =>
  axios(
    "/museum_traffic_info", {
    p: PLAT,
    museum_id: MID,
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
//获取下拉列表选项数据
const get_select_list = () =>
  axios(
    "/volunteer/select_list", {
    p: PLAT,
    museum_id: MID,
  },
    "GET", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );
//提交志愿者信息
const post_info = (data) =>
  axios(
    "/volunteer/post_info", {
    p: PLAT,
    museum_id: MID,
    ...data
  },
    "POST", {
    isLoading: true,
    loadingText: '加载中...'
  }
  );

export default {
  get_traffic_info,
  get_select_list,
  post_info
}





// WEBPACK FOOTER //
// ./src/http/modules/service.js